import { cx } from '@emotion/css';
import { useCallback, useEffect, useRef } from 'react';

import { Design } from 'apps/shared/scripts/__generated__/graphql.generated';

import {
  activeClassName,
  captionClassName,
  designGalleryItemClassName,
  imageClassName,
  innerClassName,
  labelClassName,
  overlayClassName,
  pictureClassName,
  wrapperClassName,
} from './styles';

interface Props {
  design: Design;
  isActive: boolean;
  onSelect: (id: string) => void;
}

const DesignGalleryItem = ({ design, isActive, onSelect }: Props) => {
  const { background, name } = design;
  const ref = useRef<HTMLDivElement | null>(null);

  const onClick = useCallback(() => {
    onSelect(design.id);
  }, [design.id, onSelect]);

  useEffect(() => {
    // scroll to active item on load
    if (ref.current && isActive) {
      document.getElementById('carousel')!.scrollTo({
        left: ref.current.offsetLeft - 4,
      });
    }
  }, []); // eslint-disable-line

  return (
    <div
      className={designGalleryItemClassName}
      onClick={onClick}
      role="button"
      ref={ref}
    >
      {isActive && <div className={overlayClassName} />}
      <div className={wrapperClassName}>
        <div className={innerClassName}>
          <picture className={pictureClassName}>
            <img className={imageClassName} src={background.src} alt={name} />
          </picture>
          <div className={captionClassName}>
            <span
              className={cx(labelClassName, { [activeClassName]: isActive })}
            >
              {name}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

DesignGalleryItem.displayName = 'DesignGalleryItem';

export default DesignGalleryItem;
